import { AddressModel, ModificationDataModel, ValidationMessageModel } from '@data-layer/models/common';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { enumIdentifierQualifier } from '@data-layer/enums/common';

export class EntityModel {
  public id: number;
  public invoiceId?: number; //FE only field
  public name: string;
  public entityCode: enumEntityModelCode;
  public entityIdentifier: string;
  public entityIdentifierQualifier: enumIdentifierQualifier;
  public dateOfBirth: string; // ($date-time)
  public address: AddressModel;
  public addressId: number;
  public validationMessages: ValidationMessageModel[];
  public phone: string;
  public email: string;
  public fax: string;
  public modificationData: ModificationDataModel;

  constructor(model?: Partial<EntityModel>) {
    Object.assign(this, model);
  }
}
